import * as React from "react";
import {Component} from "react";
import {DashboardValueVsExpectedCell} from "../base/DashboardValueVsExpectedCell";
import {EmptyCell} from "../base/EmptyCell";
import { withTranslation } from 'react-i18next';

export class DashboardCurrentCostVsTimeCellClass extends Component {
    render() {
        if(this.props.data === undefined)
            return <EmptyCell/>

        return <DashboardValueVsExpectedCell value={this.props.data.formatted_value}
                                             alertLevel={this.props.data.alert_level}
                                             alertSnoozed={this.props.data.alert_snoozed}
                                             fluctuation={this.props.data.fluctuation}
                                             fluctuationPercentage={this.props.data.fluctuation_formatted_percentage}
                                             title={this.titleFor()}
                                             status={this.props.data.status}
        />;
    }

    titleFor() {
        const { t } = this.props;
        return t('dashboard_current_cost_vs_time_cell.title', {
            invested: this.props.data.formatted_value,
            timePassed: this.props.data.formatted_expected_value
        });
    }
}

export const DashboardCurrentCostVsTimeCell = withTranslation()(DashboardCurrentCostVsTimeCellClass);
export default DashboardCurrentCostVsTimeCell;
